<template>
  <div v-if="info" class="container-info-facility">
    <div class="info-all-facility info_2">
      <p class="m-0 c-body2 fw-600">{{ $t("wap.text176") }}</p>
      <div>
        <img class="mr-5" src="@/assets/img/v3/icon/icon_star_1.svg" alt="" />
        <span class="c-caption mr-5">{{ infoReview.review_rating }}/5 </span>
        <span class="c-caption  c-text-p "
          >({{ infoReview.count }} reviews)</span
        >
      </div>
      <div class="hr-w-70 mt-10 mb-10"></div>
      <div class="user-feedback">
        <div class="d-flex algin-items-center">
          <span class=" c-caption mr-10 c-text-p"
            >{{ $t("wap.text177") }}:
          </span>
          <el-rate class="mt-2" v-model="rate" :colors="colors"> </el-rate>
        </div>
        <div
          style="margin-bottom:30px"
          class="d-flex  justify-content-between algin-items-center mt-10 "
        >
          <div class="info-customer w-100 d-flex">
            <el-avatar
              class="flex-shrink-0 mr-10"
              :size="35"
              :src="
                infoUser?.avatar ||
                  'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
              "
            >
            </el-avatar>
            <el-input :placeholder="$t('wap.text178')" v-model="content">
            </el-input>
            <img
              @click="sendFeedBack"
              class="ml-10"
              :src="bg.icon_fly"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="list-feedback mt-20">
        <div
          v-for="item in listFeed"
          :key="item.id"
          style="border-bottom: 1px solid #e5e7eb"
          class="d-flex  justify-content-between algin-items-center mb-10"
        >
          <div class="info-customer d-flex">
            <el-avatar
              class="flex-shrink-0 mr-10"
              :size="35"
              :src="item.review_avatar"
            >
            </el-avatar>
            <div>
              <p class="m-0 c-caption fw-600">{{ item.review_name }}</p>
              <p class=" m-0 c-caption c-text-p">
                {{ formatDateTime(item.created_at, "hh:mm DD/MM/YYYY") }}
              </p>
              <p class=" c-caption c-text-p">{{ item.review_content }}</p>
            </div>
          </div>
          <div class="rating">
            <img
              v-for="(rating, index) in [1, 2, 3, 4, 5]"
              :key="`${item.id}-${index}`"
              class="ml-2"
              :src="rating > rating.review_rating ? iconStart : iconStart1"
              alt="icon start"
            />
          </div>
        </div>
        <div v-if="total > listFeed.length" class="mt-20 mb-20 text-center">
          <button-customer
            style="width:120px"
            :styles="{
              fontSize: '12px',
              fontWeight: 500,
              height: '40px',
              borderRadius: '20px',
              padding: '5px 0px'
            }"
            :loading-submit="isLoading"
            :object-data="{ title: $t('viewMore') }"
            @on-action="loadMore"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBackGround, getToken } from "@/utils/wapAuth";
import { getInfo } from "@/utils/auth.js";
import { isEmpty } from "@/utils/validate";

import { formatDateTime } from "@/utils/formatData";
import ReviewFacility from "@/views/api/wapV2/review-facility";
import ButtonCustomer from "@/components/wapV2/button/index.vue";

export default {
  name: "info-feedback-facility",
  components: {
    ButtonCustomer
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    facilityId: {
      default: ""
    }
  },
  created() {
    this.onGetList();
  },
  mounted() {},
  computed: {},
  watch: {
    "$store.getters.isReRenderComponent": function(newValue) {
      if (newValue > 1 && !isEmpty(getToken().vga)) {
        this.infoUser = getInfo();
      }
    }
  },

  data() {
    return {
      isLoading: false,
      loadingSubmit: false,
      total: 0,
      listFeed: [],
      infoReview: {},
      visibleCount: 8,
      page: 1,
      infoUser: getInfo(),
      bg: getBackGround(),
      iconStart1: require("@/assets/img/v3/icon/icon_star_1.svg"),
      iconStart: require("@/assets/img/v3/icon/icon_star.svg"),
      content: "",
      colors: ["#99A9BF", "#F7BA2A", "rgb(236, 67, 0)"],
      rate: 5
    };
  },
  methods: {
    formatDateTime,
    getToken,
    loadMore() {
      this.page += 1;
      this.onGetList(true);
    },
    onGetList(loadMore = false) {
      this.isLoading = true;
      const params = { id: this.facilityId, page: this.page };
      ReviewFacility.list_feedback_facility(params)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            const { count, reviews } = data;
            this.infoReview = count[0];
            this.total = reviews.total;
            if (loadMore) {
              this.listFeed = [...this.listFeed, ...reviews.data];
            } else {
              this.listFeed = reviews.data;
            }

            console.log("this.infoReview_________", this.infoReview);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    sendFeedBack() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      if (!this.content) {
        this.$message.warning("Vui lòng viết bình luận.");
        return;
      }
      const body = {
        flight_id: 0,
        review_golfer_id: this.infoUser.vga,
        review_name: this.infoUser.fullname,
        review_avatar: this.infoUser.avatar,
        review_content: this.content,
        review_rating: this.rate
      };
      const params = { id: this.facilityId };
      ReviewFacility.send_feedback_facility(params, body)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            this.content = "";
            this.page = 1;
            this.onGetList();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style></style>

<style scoped lang="scss">
.container-info-facility {
  .info-all-facility {
    margin-bottom: 20px;
    padding: 10px 15px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
  }
  .info-1 {
    span {
      font-size: 14px;
    }
  }
  .c-text-p {
    color: #4b5563;
  }
  .bg-color-table {
    background-color: #f3f5f6;

    border-radius: 8px;
  }
}
.hr-w-70 {
  width: 70px;
  height: 1px;
  background-color: #e5e7eb;
}
.hr-div {
  height: 1px;
  background-color: #e5e7eb;
}
.title-h3 {
  font-size: 16px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.text-see-more {
  color: #858585;
  font-size: 12px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none !important;
  }
  .mobile {
    display: block;
  }
  .container-info-facility {
    .info-all-facility {
    }
    .info-1 {
      span {
        font-size: 12px;
      }
    }
  }
}
</style>
